export default {"src":"/_next/static/media/fb.1d9f4c6b.svg","height":12,"width":6};